var map = {
	"./cover2.png": "./src/EGRContent/Story/TimiKKhanchau/images/cover2.png",
	"./coverimage.png": "./src/EGRContent/Story/TimiKKhanchau/images/coverimage.png",
	"./imgs/aeroplane_top.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/aeroplane_top.png",
	"./imgs/boats.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/boats.svg",
	"./imgs/bus.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/bus.svg",
	"./imgs/bus2.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/bus2.svg",
	"./imgs/bus3.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/bus3.svg",
	"./imgs/bus4.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/bus4.svg",
	"./imgs/cycling.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/cycling.gif",
	"./imgs/cycling.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/cycling.svg",
	"./imgs/dikkri.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/dikkri.png",
	"./imgs/fooda.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/fooda.png",
	"./imgs/foodb.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodb.png",
	"./imgs/foodc.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodc.png",
	"./imgs/foodd.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodd.png",
	"./imgs/foode.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foode.png",
	"./imgs/foodf.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodf.png",
	"./imgs/foodg.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodg.png",
	"./imgs/foodh.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodh.png",
	"./imgs/foodi.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodi.png",
	"./imgs/foodj.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodj.png",
	"./imgs/foodk.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodk.png",
	"./imgs/foodl.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodl.png",
	"./imgs/foodo1.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo1.png",
	"./imgs/foodo2.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo2.png",
	"./imgs/foodo3.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo3.png",
	"./imgs/foodo4.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo4.png",
	"./imgs/foodo5.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo5.png",
	"./imgs/foodo6.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/foodo6.png",
	"./imgs/girl01.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl01.gif",
	"./imgs/girl01.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl01.png",
	"./imgs/girl02.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl02.gif",
	"./imgs/girl02.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl02.png",
	"./imgs/girl03.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl03.png",
	"./imgs/girl04.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl04.png",
	"./imgs/girl05.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl05.png",
	"./imgs/girl_cycle.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl_cycle.gif",
	"./imgs/girl_cycle.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/girl_cycle.png",
	"./imgs/gohara_anda.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/gohara_anda.png",
	"./imgs/green_location.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/green_location.png",
	"./imgs/hati_paile_tarul.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/hati_paile_tarul.png",
	"./imgs/horse.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/horse.gif",
	"./imgs/horse.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/horse.svg",
	"./imgs/horse_girl.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/horse_girl.png",
	"./imgs/kamal.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamal.gif",
	"./imgs/kamal.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamal.svg",
	"./imgs/kamal_bothhandhip.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamal_bothhandhip.svg",
	"./imgs/kamal_onehandhip.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamal_onehandhip.svg",
	"./imgs/kamal_smile.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamal_smile.svg",
	"./imgs/kamallaugh.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/kamallaugh.png",
	"./imgs/koshitapu_gate.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/koshitapu_gate.png",
	"./imgs/map.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/map.png",
	"./imgs/map.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/map.svg",
	"./imgs/map2.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/map2.png",
	"./imgs/map2old.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/map2old.png",
	"./imgs/map_v2-07.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/map_v2-07.svg",
	"./imgs/mountain_temple.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/mountain_temple.png",
	"./imgs/onetree.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/onetree.png",
	"./imgs/plane.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/plane.svg",
	"./imgs/sanpa.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/sanpa.png",
	"./imgs/talking_bothhandhip.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/talking_bothhandhip.gif",
	"./imgs/talking_onehandhip.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/talking_onehandhip.gif",
	"./imgs/talkingkamal.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/talkingkamal.gif",
	"./imgs/talkingkamalhandup.gif": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/talkingkamalhandup.gif",
	"./imgs/taruwa.png": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/taruwa.png",
	"./imgs/van.svg": "./src/EGRContent/Story/TimiKKhanchau/images/imgs/van.svg",
	"./thumbnail.png": "./src/EGRContent/Story/TimiKKhanchau/images/thumbnail.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/TimiKKhanchau/images sync recursive ^\\.\\/.*$";